(() => {
  const getDrawer = () => document.getElementById('CartDrawer');
  const getBackdrop = () => document.querySelector('[data-cart-drawer-backdrop]');

  function openDrawer() {
    const drawer = getDrawer();
    const backdrop = getBackdrop();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    const drawer = getDrawer();
    const backdrop = getBackdrop();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
  }

  function updateHeaderCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
    });
  }

  async function refreshDrawer() {
    const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!res.ok) return;
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newDrawer = doc.getElementById('CartDrawer');
    const newBackdrop = doc.querySelector('[data-cart-drawer-backdrop]');
    const oldDrawer = getDrawer();
    const oldBackdrop = getBackdrop();
    if (newDrawer && oldDrawer) {
      const wasOpen = oldDrawer.classList.contains('is-open');
      newDrawer.classList.toggle('is-open', wasOpen);
      newDrawer.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');
      if (wasOpen) {
        newDrawer.removeAttribute('inert');
      } else {
        newDrawer.setAttribute('inert', '');
      }
      oldDrawer.replaceWith(newDrawer);
      if (newBackdrop && oldBackdrop) {
        newBackdrop.classList.toggle('is-open', wasOpen);
        oldBackdrop.replaceWith(newBackdrop);
      }
    }
  }

  async function changeLineItem(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const cartData = await res.json();
    updateHeaderCartCount(cartData.item_count);
    await refreshDrawer();
  }

  async function clearCart() {
    const res = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: '',
    });
    const cartData = await res.json();
    updateHeaderCartCount(cartData.item_count);
    await refreshDrawer();
  }

  // FIX (2026-09-27): this is now the ONLY code path that submits the add-to-cart
  // request. It used to run alongside an identical handler in arbasa-theme.js —
  // both listened for the same form submit and both POSTed to the cart, so every
  // "Add to cart" click added the item twice and fired Shopify's cart-tracking
  // events (which feed the Meta Pixel's AddToCart/InitiateCheckout counts) twice.
  // arbasa-theme.js's toast notification now listens for the
  // 'arbasa:cart-add-success' event dispatched below instead of re-submitting.
  async function addToCart(form) {
    const formData = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => null);
      return { ok: false, error: err };
    }
    const item = await res.json();
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    updateHeaderCartCount(cart.item_count);
    await refreshDrawer();
    document.dispatchEvent(new CustomEvent('arbasa:cart-add-success', { detail: { item, cart } }));
    return { ok: true };
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-cart-drawer-toggle]');
    if (toggle) {
      event.preventDefault();
      openDrawer();
      return;
    }

    const closeBtn = event.target.closest('[data-cart-drawer-close]');
    if (closeBtn) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const backdrop = event.target.closest('[data-cart-drawer-backdrop]');
    if (backdrop) {
      closeDrawer();
      return;
    }

    const dec = event.target.closest('[data-cart-qty-decrease]');
    if (dec) {
      const item = dec.closest('[data-cart-item]');
      const key = item.dataset.key;
      const qtyEl = item.querySelector('[data-cart-qty]');
      const newQty = Math.max(0, parseInt(qtyEl.textContent, 10) - 1);
      changeLineItem(key, newQty);
      return;
    }

    const inc = event.target.closest('[data-cart-qty-increase]');
    if (inc) {
      const item = inc.closest('[data-cart-item]');
      const key = item.dataset.key;
      const qtyEl = item.querySelector('[data-cart-qty]');
      const newQty = parseInt(qtyEl.textContent, 10) + 1;
      changeLineItem(key, newQty);
      return;
    }

    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      const item = remove.closest('[data-cart-item]');
      const key = item.dataset.key;
      changeLineItem(key, 0);
      return;
    }

    const clear = event.target.closest('[data-cart-clear]');
    if (clear) {
      event.preventDefault();
      clearCart();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  // FIX (2026-09-28, ATC dedupe test): Shopify's storefront event listener counts
  // BOTH the native <form action="/cart/add"> submit AND the /cart/add.js fetch as
  // product_added_to_cart, so every click reached GA4 and Meta twice. We now stop
  // the native submit at the click/Enter stage (so it never fires) and add via
  // fetch only. The submit listener stays as a fallback for programmatic submits.
  const addFormSelector = 'form[action*="/cart/add"]';

  function runAdd(form, button) {
    const btn = button || form.querySelector('[type="submit"]:not([name="return_to"])');
    if (btn) {
      if (btn.disabled) return;
      btn.disabled = true;
    }
    addToCart(form).then((result) => {
      if (btn) btn.disabled = false;
      if (result.ok) openDrawer();
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[type="submit"], input[type="submit"]');
    if (!button || button.name === 'return_to') return;
    const form = button.closest(addFormSelector);
    if (!form) return;
    event.preventDefault();
    runAdd(form, button);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || event.defaultPrevented) return;
    const field = event.target;
    if (!field || field.tagName === 'TEXTAREA' || field.tagName === 'BUTTON') return;
    const form = field.closest && field.closest(addFormSelector);
    if (!form) return;
    event.preventDefault();
    runAdd(form);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(addFormSelector);
    if (!form) return;
    const submitter = event.submitter;
    if (submitter && submitter.name === 'return_to') return;
    event.preventDefault();
    runAdd(form, submitter);
  });
})();
